import './App.css';
import { RouterProvider } from 'react-router-dom';
import { router } from './Routes/Routes';
import toast, { Toaster } from 'react-hot-toast';
import ScrollToTop from "react-scroll-to-top";

function App() {
  return (
    <div className="App">
      <ScrollToTop smooth color="#e65f78" style={{ borderRadius: '50%' }} className='top-arrow' />
      <Toaster />
      <RouterProvider router={router}></RouterProvider>
    </div>
  );
}

export default App;
